// extracted by mini-css-extract-plugin
export default {"pageBreakText":"PageBreak_pageBreakText__RY7uj"};